import { JwtAxios } from '@/packaging';

export const dashboardApi = {
  async GetLast7DaysOrderInfo() {
    const res = await JwtAxios.get(`/Dashboard/GetLast7DaysOrderInfo`);
    return res;
  },
  async GetInformations(type,host) {
    const res = await JwtAxios.get(`/Dashboard/GetInformations?type=${type}&host=${host}`);
    return res;
  },
  async GetInformationsMore(type, page, maxRow,host) {
    const res = await JwtAxios.get(
      `/Dashboard/GetInformationsMore?type=${type}&host=${host}&page=${page}&maxRow=${maxRow}`
    );
    return res;
  },
  async CheckPcc(body) {
    const res = await JwtAxios.post('/Dashboard/CheckPcc', body);
    return res;
  },
  async GetPopupNoticeList(host) {
    const res = await JwtAxios.get(`/Dashboard/GetPopupNoticeList?host=${host}`);
    return res;
  }
};
